import { Component, model, OnInit, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RoleService } from '../../role/role.service';
import { catchError, of } from 'rxjs';

import { AdminService } from '../services/admin.service';
import { WarningsDialogComponent } from '../shared/warnings-dialog/warnings-dialog.component';

@Component({
    selector: 'app-admin-main',
    templateUrl: './admin-main.component.html',
    styleUrls: ['./admin-main.component.scss'],
    standalone: false
})
export class AdminMainComponent implements OnInit {
  error = false;

  isAdmin = signal(false);

  loading = signal(false);

  sidebarOpened = model<boolean>(true);

  warnings;

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
    private roleService: RoleService,
  ) {}

  ngOnInit() {
    this.roleService.can('read', 'admin').subscribe((isAdmin: boolean) => {
      if (!isAdmin) return;

      this.isAdmin.set(true);
      this.getWarnings();
    });
  }

  getWarnings() {
    this.loading.set(true);
    this.adminService.configuration_warnings().pipe(
      catchError(() => {
        this.error = true;
        this.loading.set(false);
        return of(null);
      }),
    ).subscribe((response) => {
      if (!response) return;

      this.warnings = response.body;
      this.loading.set(false);
    });
  }

  openWarningsDialog() {
    this.dialog.open(WarningsDialogComponent, { data: { warnings: this.warnings } })
      .afterClosed().subscribe((warnings) => {
        this.warnings = warnings;
      });
  }
}
